
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "a2ed8fdf-28bf-49d0-96e0-9ae575616ca1"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/src/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
